import settings from '../liferay/settings';
import ApiUtils from '../liferay/ApiUtils';

/** Специальные действия для получения информации о wiki страницах
 * Например, список нодов, вложенных страниц
 */
export const XSDActions = {
  EMPTY: () => ({
    type: "XSDActions.EMPTY",
  }),
  LOAD_STARTED: () => ({
    type: "XSDActions.LOAD_STARTED",
  }),
  LOAD_ERROR: (error) => ({
    type: "XSDActions.LOAD_ERROR",
    error,
  }),
  XSD: (content) => ({
    type: "XSDActions.XSD",
    content,
  }),

  /** Загрузить список доступных wiki узлов */
  setXSDContent: (content) => dispatch => {
    dispatch(XSDActions.XSD(content));
    return Promise.resolve(content);
  },

};
